import { combineReducers, Dispatch, Action, AnyAction } from 'redux'
import { all, fork } from 'redux-saga/effects'

import { LayoutState, layoutReducer } from './layout'

import heroesSaga from './heroes/sagas'
import { heroesReducer } from './heroes/reducer'
import { HeroesState } from './heroes/types'
import projectsSaga from './projects/sagas'
import { projectsReducer } from './projects/reducer'
import { ProjectsState } from './projects/types'

import eventsSaga from './events/sagas'
import { EventsState } from './events/types'
import { eventsReducer } from './events/reducer'

import blogsSaga from './blogs/sagas'
import { BlogsState } from './blogs/types'
import { blogsReducer } from './blogs/reducer'

import resourcesSaga from './resources/sagas'
import { ResourceState } from './resources/types'
import { ResourceReducer } from './resources/reducer'

import authorsSaga from './authors/sagas'
import { AuthorState } from './authors/types'
import { AuthorReducer } from './authors/reducer'

import pagesSaga from './pages/sagas'
import { PageState } from './pages/types'
import { PageReducer } from './pages/reducer'

import textSaga from './texts/sagas'
import { TextState } from './texts/types'
import { TextReducer } from './texts/reducer'

import imagesSaga from './images/sagas'
import { ImagesState } from './images/types'
import { imagesReducer } from './images/reducer'

import teamsSaga from './teams/sagas'
import { TeamsState } from './teams/types'
import { teamsReducer } from './teams/reducer'

import flickrSaga from './flickr/sagas'
import { FlickrState } from './flickr/types'
import { flickrReducer } from './flickr/reducer'

import contactSaga from './contact/sagas'
import { ContactState } from './contact/types'
import { ContactReducer } from './contact/reducer'
// The top-level state object
export interface ApplicationState {
  layout: LayoutState
  heroes: HeroesState
  projects: ProjectsState
  events: EventsState
  blogs: BlogsState
  resources: ResourceState
  authors: AuthorState
  texts: TextState
  images: ImagesState
  teams: TeamsState
  flickr: FlickrState
  contact: ContactState
}

// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const rootReducer = combineReducers<ApplicationState>({
  layout: layoutReducer,
  heroes: heroesReducer,
  projects: projectsReducer,
  events: eventsReducer,
  blogs: blogsReducer,
  resources: ResourceReducer,
  authors: AuthorReducer,
  pages: PageReducer,
  texts: TextReducer,
  images: imagesReducer,
  teams: teamsReducer,
  flickr: flickrReducer,
  contact: ContactReducer
})

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
  yield all([
    fork(heroesSaga),
    fork(projectsSaga),
    fork(eventsSaga),
    fork(blogsSaga),
    fork(resourcesSaga),
    fork(authorsSaga),
    fork(pagesSaga),
    fork(textSaga),
    fork(imagesSaga),
    fork(teamsSaga),
    fork(flickrSaga),
    fork(contactSaga)
  ])
}
